import React from 'react'
import { WrapperFooter } from './style'

const FooterCompoment = () => {
  return (
    <WrapperFooter>FooterCompoment</WrapperFooter>
  )
}

export default FooterCompoment